import { Tooltip } from "@blueprintjs/core";
import classNames from "classnames";
import InfoIcon from "components/common/InfoIcon";
import React from "react";
import "./FilterWrapper.scss";

type FilterWrapperProps = {
    readonly label?: string | React.ReactElement;
    readonly helperText?: React.ReactElement | string;
    readonly limitInputMaxWidth?: boolean;
    readonly limitLabelMaxWidth?: boolean;
    readonly alignLabelToTop?: boolean;
    readonly wideLabel?: boolean;
    readonly wideInput?: boolean;
    // Rendered under the row, flush with the input's right edge.
    readonly footer?: React.ReactNode;
    readonly children?: React.ReactNode;
};

const FilterWrapper: React.FC<FilterWrapperProps> = (props) => {
    const {
        label,
        children,
        helperText,
        limitInputMaxWidth,
        limitLabelMaxWidth,
        alignLabelToTop,
        wideLabel,
        wideInput,
        footer
    } = props;

    const maybeInfoIcon = helperText && (
        <Tooltip
            content={
                <div className="FilterWrapper-popover-content-wrapper">
                    {helperText}
                </div>
            }
            placement="top"
        >
            <InfoIcon />
        </Tooltip>
    );

    return (
        <div className="FilterWrapper-wrapper">
            <div className="FilterWrapper-row">
                {label !== undefined && (
                    <div
                        className={classNames("FilterWrapper-label", {
                            "FilterWrapper-label-max-width": limitLabelMaxWidth,
                            "FilterWrapper-label-align-top": alignLabelToTop,
                            "FilterWrapper-label-wide": wideLabel
                        })}
                    >
                        {label}
                        {maybeInfoIcon}
                    </div>
                )}
                <div
                    className={classNames("FilterWrapper-input", {
                        "FilterWrapper-input-max-width": limitInputMaxWidth,
                        "FilterWrapper-input-wide": wideInput
                    })}
                >
                    {children}
                </div>
            </div>
            {footer !== undefined && (
                <div className="FilterWrapper-footer">{footer}</div>
            )}
        </div>
    );
};

export default FilterWrapper;
